import templateUrl from "emun.report/report-params.htm";
import controller from 'emun.report/report-params.controller'
import open from 'webmodals/open'


export default options => open(Object.assign({
	templateUrl,
	resolve: {
		options: () => options,
	},
	bindToController: true,
	backdrop: "static",
	controller,
	controllerAs: "$ctrl",
	size: "lg",
}, (options || {}).modal)).result;